import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {PageTitleLayoutComponent} from "../../../components/page-title-layout/page-title-layout.component";
import {Image} from "primeng/image";
import {ArticleService} from "../../../services/article.service";
import {RouterLink} from "@angular/router";


import {DatePipe, JsonPipe} from "@angular/common";
import {
  LotteriesAndFooterComponent
} from "../../../components/lotteries-and-footer/lotteries-and-footer.component";
import {TranslocoPipe} from "@jsverse/transloco";

@Component({
  selector: 'homey-articles-overview-page',
  imports: [
    PageTitleLayoutComponent,
    Image,
    RouterLink,
    DatePipe,
    LotteriesAndFooterComponent,
    TranslocoPipe,
    JsonPipe
  ],
  templateUrl: './articles-overview-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticlesOverviewPageComponent {
  public readonly articles = inject(ArticleService).getArticles();
}
